import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const ServiceTypeApi = {
    fetch: (query, options) => get(`/services/types?${qs.stringify(query)}`, options),
    fetchById: (id) => get(`/services/types/${id}`),
    create: (data) => post('/services/types', data),
    update: (id, data) => put(`/services/types/${id}`, data),
    delete: (id) => del(`/services/types/${id}`),
};
